<template>

    <div class="geostatus-map"
         style="height: 100%;
        width: 100%;
        text-align: center;
        overflow: hidden;
    ">
        <template v-if="reviewDone == false">
            <fish-modal :width=350 id="review-modal" :visible.sync="showModal">
                <closeIcon id="closeIcon" @click.native="closeModal"></closeIcon>
                <label>{{$t('geoStatusMap.makeReviewHint')}}</label>
                <fish-form>
                    <fish-field id="review-modal-grade">
                        <star-rating v-model="reviewGrade" inactive-color="#000"
                                     active-color="rgb(254, 204, 0)" :show-rating=false :item-size="18"
                                     border-color="ghostwhite" :spacing="20">
                        </star-rating>
                    </fish-field>
                    <fish-field id="review-modal-comment">
                        <fish-input type="textarea" hint="" v-model="reviewComment"></fish-input>
                    </fish-field>
                    <fish-button :loading="isLoading" type="primary" @click="makeReview">{{$t('geoStatusMap.makeReviewSubmit')}}</fish-button>
                </fish-form>
            </fish-modal>
        </template>
        <innerLogo id="geostatus_innerLogo" />
        <fish-field id="key-input">
            <input disabled
                   id="mapInput"
                   placeholder="DEMONSTRATION">
            <inputButton disabled name="mapInputButton" id="mapInputButton" style="cursor: default" />
        </fish-field>
        <a id="geostatus_label_kz" href="https://geostatus.net" style="color: #FFFFFF;">net</a>
        <a id="geostatus_label" href="https://geostatus.net" style="color: #A2D9F7;">geostatus.</a>
        <yandex-map :coords="centerCoords"
                    :zoom="zoom"
                    style="height: 100%;
        width: 100%;
        overflow: hidden;"
                    :scroll-zoom="true"
                    :behaviors="['scrollZoom', 'drag', 'multiTouch']"
                    :controls="['trafficControl', 'geolocationControl']"
                    :placemarks="placemarks"
                    :settings="settings"
                    map-type="map"
                    @map-was-initialized="initHandler">

        </yandex-map>
        <loading :active.sync="isLoading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
    </div>
</template>

<script>
    import { yandexMap, ymapMarker } from 'vue-yandex-maps'
    import innerLogo from '../assets/img/innerLogo.vue'
    import inputButton from '../assets/img/inputButton.vue';
    import { StarRating } from 'vue-rate-it';
    import { visit } from '../models';
    import courierIcon from '../assets/img/courierIcon.svg';
    import homeIcon from '../assets/img/homeIcon.svg';
    import homeFinishIcon from "../assets/img/homeIcon_finish.svg";
    import closeIcon from "../assets/img/closeIcon.vue";
    import loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {
        name: "visitMap",
        data() {
            return {
                timer: '',
                map: {},
                placemarks: [],
                settings: {
                    lang: this.$i18n.locale == "en" ? 'en_US' : this.$i18n.locale == "tr" ? "tr_TR" : "ru_RU"
                },
                model: new visit(),
                zoom: 13,
                reviewGrade: undefined,
                reviewComment: undefined,
                reviewDone: false,
                rating: 0,
                centerCoords: [48, 67],
                isLoading: true,
                showModal: false,
                points: [[43.25898, 76.93011],
                [43.2673, 76.9486],
                [43.26737, 76.94859],
                [43.2673, 76.94688],
                [43.266761, 76.947011],
                [43.265828, 76.947097],
                [43.26396, 76.94508],
                [43.26383, 76.94338],
                [43.2637, 76.94143],
                [43.26365, 76.94057],
                [43.26277, 76.9352],
                [43.26215, 76.93528],
                [43.26188, 76.93531],
                [43.261321, 76.935405],
                [43.26124, 76.93439],
                [43.26112, 76.93307],
                [43.26112, 76.93229],
                [43.26096, 76.93069],
                [43.260962, 76.930260],
                [43.260845, 76.930276],
                [43.260499, 76.930317],
                [43.260177, 76.930328],
                [43.25983, 76.9303],
                [43.25973, 76.93021],
                [43.25936, 76.93024],
                [43.25894, 76.93026],
                [43.25898, 76.93011]]
            }
        },
        components: { yandexMap, ymapMarker, innerLogo, inputButton, loading, StarRating, closeIcon },
        methods: {
            initHandler(map) {
                this.map = map;
                this.fetchVisit();
                console.log("locale", this.$i18n.locale)
            },
            messageErrorHandler(message) {
                this.$message.error(message, 3000)
            },
            messageSuccessHandler(message) {
                this.$message.success(message, 3000)
            },
            getReview() {
                this.reviewDone = false;
                this.showModal = true;
            },
            async fetchVisit() {
                this.isLoading = false;
                this.model.objectLatitude = this.points[this.points.length - 1][0];
                this.model.objectLongitude = this.points[this.points.length - 1][1];

                for (var i = 0; i < this.points.length; i++) {
                    if (i == 0) {
                        this.model.visitStatus = "Assigned";
                        this.centerCoords = [this.model.objectLatitude, this.model.objectLongitude];

                        this.placemarks = [
                            {
                                coords: [this.model.objectLatitude, this.model.objectLongitude],
                                properties: {
                                    balloonContent: this.$t('geoStatusMap.objectBalloonContentTitle'),
                                },
                                options: {
                                    iconLayout: 'default#image',
                                    iconImageHref: homeIcon,
                                    iconImageSize: [50, 88],
                                    iconImageOffset: [-15, -75],
                                },
                                markerId: 1
                            }];

                        this.map.setZoom(17);
                        await this.sleep(2000);
                        continue;
                    }
                    if (i == this.points.length - 1) {
                        this.model.visitStatus = "Completed";
                        this.centerCoords = [this.model.objectLatitude, this.model.objectLongitude];

                        this.placemarks = [
                            {
                                coords: [this.model.objectLatitude, this.model.objectLongitude],
                                properties: {
                                    balloonContent: this.$t('geoStatusMap.objectBalloonContentTitle'),
                                },
                                options: {
                                    iconLayout: 'default#image',
                                    iconImageHref: homeFinishIcon,
                                    iconImageSize: [50, 88],
                                    iconImageOffset: [-15, -75],
                                },
                                markerId: 1
                            }];

                        this.map.setZoom(17);
                        await this.sleep(1000);
                        this.getReview();
                        continue;
                    }

                    this.model.userLatitude = this.points[i][0];
                    this.model.userLongitude = this.points[i][1];

                    this.placemarks = [
                        {
                            coords: [this.model.objectLatitude, this.model.objectLongitude],
                            properties: {
                                balloonContent: this.$t('geoStatusMap.objectBalloonContentTitle'),
                            },
                            options: {
                                iconLayout: 'default#image',
                                iconImageHref: homeIcon,
                                iconImageSize: [50, 88],
                                iconImageOffset: [-15, -75],
                            },
                            markerId: 1
                        },
                        {
                            coords: [this.model.userLatitude, this.model.userLongitude],
                            properties: {
                                balloonContent: this.$t('geoStatusMap.workerBalloonContentTitle'),
                            },
                            options: {
                                iconLayout: 'default#image',
                                iconImageHref: courierIcon,
                                iconImageSize: [50, 88],
                                iconImageOffset: [-15, -75],
                            },
                            markerId: 2
                        }];

                    this.map.setCenter(this.findMiddleCoords(this.model));
                    this.map.setZoom(this.calculateZoom(this.model));
                    await this.sleep(1000);
                }
            }
            ,
            findMiddleCoords(model) {
                const center = [((model.objectLatitude + model.userLatitude) / 2), ((model.userLongitude + model.objectLongitude) / 2)];
                return center;
            },
            sleep(ms) { return new Promise(resolve => setTimeout(resolve, ms)); },
            calculateDistance(lat1, lon1, lat2, lon2) {
                if ((lat1 == lat2) && (lon1 == lon2)) {
                    return 0;
                }
                else {
                    var radlat1 = Math.PI * lat1 / 180;
                    var radlat2 = Math.PI * lat2 / 180;
                    var theta = lon1 - lon2;
                    var radtheta = Math.PI * theta / 180;
                    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
                    if (dist > 1) {
                        dist = 1;
                    }
                    dist = Math.acos(dist);
                    dist = dist * 180 / Math.PI;
                    dist = dist * 60 * 1.1515;
                    dist = dist * 1.609344;
                    return dist;
                }
            },
            calculateZoom(model) {
                const distance = this.calculateDistance(model.objectLatitude, model.objectLongitude, model.userLatitude, model.userLongitude);
                if (distance <= 0.2)
                    return 18;
                else if (distance <= 0.5)
                    return 17;
                else if (distance <= 1)
                    return 16;
                else if (distance <= 5)
                    return 14;
                else if (distance <= 10)
                    return 13;
                else if (distance <= 20)
                    return 12;
                else if (distance <= 40)
                    return 11;
                else if (distance <= 70)
                    return 10;
                else if (distance <= 150)
                    return 9;
                else if (distance <= 300)
                    return 8;
                else if (distance <= 600)
                    return 7;
                else if (distance <= 1200)
                    return 6;
                else return 5;
            },
            makeReview() {
                this.reviewDone = true;
                this.showModal = false;
                this.messageSuccessHandler(this.$t('geoStatusMap.reviewSuccessHandlerMessage'))
            },
            closeModal() {
                this.showModal = false;
            }
        }
    }

</script>


